module.exports = __webpack_public_path__ + "img/watch.31a65414.png";